import { render } from "./paris.vue?vue&type=template&id=38ce215c&scoped=true"
import script from "./paris.vue?vue&type=script&lang=js"
export * from "./paris.vue?vue&type=script&lang=js"

import "./paris.vue?vue&type=style&index=0&id=38ce215c&lang=scss&scoped=true"
import "./paris.vue?vue&type=style&index=1&id=38ce215c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38ce215c"

export default script